"use client";

import { useLanguage } from "@/i18n/LanguageContext";

const sectionKeys = [
  { h2: "privacy.h2_1", text: "privacy.text_1" },
  { h2: "privacy.h2_2", text: "privacy.text_2" },
  { h2: "privacy.h2_3", text: "privacy.text_3" },
  { h2: "privacy.h2_4", text: "privacy.text_4" },
  { h2: "privacy.h2_5", text: "privacy.text_5" },
  { h2: "privacy.h2_6", text: "privacy.text_6" },
  { h2: "privacy.h2_7", text: "privacy.text_7" },
  { h2: "privacy.h2_8", text: "privacy.text_8" },
  { h2: "privacy.h2_9", text: "privacy.text_9" },
];

export default function PolicySections() {
  const { t } = useLanguage();
  return (
    <section className="bg-white py-14 md:py-16">
      <div className="max-w-[880px] mx-auto px-4 md:px-6">
        <div className="space-y-10 md:space-y-12">
          {sectionKeys.map((sec) => (
            <div key={sec.h2}>
              <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
                {t(sec.h2)}
              </h2>
              <p className="text-base leading-[1.7] text-[#374151]">
                {t(sec.text)}
              </p>
            </div>
          ))}

          {/* Section 10 — Contact */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("privacy.h2_10")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151] mb-6">
              {t("privacy.text_10")}
            </p>
            <div className="bg-[#fefce8] rounded-xl p-6 border-l-4 border-[#047857] max-w-[600px] mx-auto">
              <p className="font-bold text-[#064e3b] text-base mb-2">
                Windows and Doors Repair LLC
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("privacy.phoneLabel")}{" "}
                <a href="tel:+17863774452" className="text-[#047857] hover:text-[#064e3b] underline font-medium">
                  (786) 377-4452
                </a>
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("privacy.emailLabel")}{" "}
                <a href="mailto:contact@impact-window-repair-miami.com" className="text-[#047857] hover:text-[#064e3b] underline">
                  contact@impact-window-repair-miami.com
                </a>
              </p>
              <p className="text-[#374151] text-sm italic">
                {t("privacy.mailLabel")} 848 Brickell Ave, PH-5, Miami, FL 33131
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}